import React from 'react'
import { format, parseISO } from 'date-fns'
import { Typography } from '@telavita-core/react-design-kit'

import { MedicalRecordFormType } from 'models/MedicalRecord/MedicalRecordForm.type'

import * as S from '../styles'

interface HeaderProps {
  patientName: string
  sessionNumber: number
  formType: MedicalRecordFormType
  planName?: string
  publishedAtUtc?: string | null
}

const FORM_TYPE_LABEL: Record<MedicalRecordFormType, string> = {
  [MedicalRecordFormType.TECHNICAL_EVALUATION]: 'avaliação',
  [MedicalRecordFormType.EVOLUTION]: 'evolução',
  [MedicalRecordFormType.OUTCOME]: 'desfecho',
}

const formatPublishedAt = (utc?: string | null): string | null => {
  if (!utc) return null
  try {
    const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(utc)
    const isoUtc = hasTimezone ? utc : `${utc}Z`
    return format(parseISO(isoUtc), 'dd/MM/yyyy, \'às\' HH:mm')
  } catch {
    return null
  }
}

export function Header({
  patientName,
  sessionNumber,
  formType,
  planName,
  publishedAtUtc,
}: HeaderProps): JSX.Element {
  const tag = FORM_TYPE_LABEL[formType] ?? 'evolução'
  const publishedAtLabel = formatPublishedAt(publishedAtUtc)

  return (
    <S.HeaderWrapper>
      <Typography variant='content2' center>
        Paciente: {patientName}
      </Typography>
      {publishedAtLabel && (
        <Typography variant='content2' center>
          Registro feito em {publishedAtLabel}
        </Typography>
      )}
      <Typography variant='content2' weight='bold' center>
        Referente a {sessionNumber}ª consulta ({tag})
      </Typography>
      {planName && <S.PlanName>{planName}</S.PlanName>}
    </S.HeaderWrapper>
  )
}
